import { useTranslation } from "react-i18next";
import { Badge } from "@/shared/ui";
import { getMonthName } from "@/shared/utils";
import type { Locale } from "@/shared/utils";
import type { ContractorPayrollAggregatedStatus } from "../../../types";
import { CONTRACTOR_PAYROLL_AGGREGATED_STATUS_MAP } from "../../../consts";

interface Props {
  month: number;
  year: number;
  locale: Locale;
  aggregatedStatus: ContractorPayrollAggregatedStatus;
}

export default function ContractorPayrollDetailHeader({ month, year, locale, aggregatedStatus }: Props) {
  const { t } = useTranslation("ContractorPayrollPage");
  const monthName = getMonthName(month, locale);
  const statusConfig = CONTRACTOR_PAYROLL_AGGREGATED_STATUS_MAP[aggregatedStatus];

  return (
    <>
      <title>{t("meta.detailTitle", { month: monthName, year })}</title>
      <div className="flex items-center justify-between pt-1 pb-4 border-b surface-base-stroke mb-5 pr-1">
        <div className="flex items-center gap-4">
          <h1 className="text-display-xs content-base-primary">
            {t("meta.pageTitle", { month: monthName, year })}
          </h1>
          <Badge variant="soft" color={statusConfig.color} text={t(statusConfig.label)} icon={statusConfig.icon} />
        </div>
      </div>
    </>
  );
}
